import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@emotion/react";
import { useLocation, useNavigate, useParams } from "react-router";
import useSWR from "swr";

import FollowBox from "./FollowBox";
import ProfileHeader from "./ProfileHeader";
import ProfileTabs from "./ProfileTabs";
import { getPlayerState } from "../../../redux/features/playerSlice";
import {
  setProfileId,
  setUserName,
} from "../../../redux/features/settingSlice";
import UseWindowDimensions from "../../../utils/windowSize";
import { getSettingState } from "../../../redux/features/settingSlice";
import CustomHelmet from "../CustomHelmet";
import { fetcherGetToken } from "../../../services/fetcher";
import CustomCircleButton from "../CustomCircleButton";
import ChatGpt from "../../../media/svg/ChatGpt";

const ProfilePage = () => {
  const theme = useTheme();
  const { minimizePlayer } = useSelector(getPlayerState);
  const dispatch = useDispatch();
  const params = useParams();
  const { height } = UseWindowDimensions();
  const navigate = useNavigate();
  const location = useLocation();
  let urlParams = location.pathname.split("/");
  const { userData } = useSelector(getSettingState);
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;

  const conditionalReq = () => {
    let mode = null;
    if (urlParams[2] === "editprofile") {
      mode = null;
    }
    if (urlParams[1] === "profile" && urlParams[2]) {
      mode = `/auth/v2/profile/${params.profileId}/`;
    } else {
      mode = `/auth/profile/${userData}/`;
    }

    return mode;
  };

  const { data: profile, isLoading } = useSWR(
    () => {
      if (!userData && !urlParams[2]) {
        return null;
      }
      return [process.env.REACT_APP_API + conditionalReq(), tokenStorage];
    },
    fetcherGetToken,
    {
      dedupingInterval: 12000,
      refreshInterval: 18000,
    }
  );

  // set profile id
  useEffect(() => {
    if (profile) {
      dispatch(setProfileId(profile.id));
    }
  }, [dispatch, profile]);

  useEffect(() => {
    if (profile) {
      dispatch(setUserName(profile.username));
      if (!userData && urlParams[2] === "editprofile") {
        navigate("/profile");
      }
    }
  }, [dispatch, navigate, profile, urlParams, userData]);

  return (
    <>
      {
        <CustomHelmet
          title={`${profile ? profile.username : "Azad"} | Profile`}
        />
      }

      <Box
        sx={{
          backgroundColor: theme.palette.white.main,
          display: "flex",
          flexDirection: "column",
          height: height - 62 - (minimizePlayer ? 82 : 0) + "px",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <ProfileHeader
          data={profile}
          isLoading={isLoading}
          myProfile={!urlParams[2]}
        />
        <FollowBox
          data={profile}
          isLoading={isLoading}
          myProfile={!urlParams[2]}
        />
        <ProfileTabs data={profile} isLoading={isLoading} />
        {userData &&
          urlParams[1] === "profile" &&
          urlParams[2] &&
          urlParams[2] !== "editprofile" && (
            profile?.gpt_enabled &&
            <Box sx={{ position: "absolute", right: "20px", bottom: "89px" }}>
              <CustomCircleButton
                onClick={() => navigate(`/profile/${urlParams[2]}/comment`)}
                width='56px'
                height='56px'
                bgColor='#00897B'
                hoverBgColor='#00897B'
                hoverColor='black.main'
                hoverBorder={`none`}
                bShadow={`0px 4px 0px ${theme.palette.black.main}`}
                activeBgColor='black.main'
                activeColor='white.main'
                border='2px solid'
              >
                <ChatGpt size={32} />
              </CustomCircleButton>
            </Box>
          )}
      </Box>
    </>
  );
};

export default ProfilePage;
